export const paths = {
  DASHBOARD: 'dashboard',
  SHIPMENTS: 'shipments',
  LOCATOR: 'locator',
  MORE: 'more',
  TRACKTRACE: 'tracktrace',
  INTERVENTIONS: 'interventions',
  C2C: 'c2c',
}

export const externalPaths = {
  PWA: 'pwa/shipment/package',
  ACCOUNT: 'account',
}
